import {useLocation} from 'react-router-dom';
import {useEffect, useState} from 'react';

const useAuthRoute = () => {
    const authRoutes = ['/login', '/sign-up', '/register'];
    const location = useLocation();
    const [isAuthRoute, setIsAuthRoute] = useState(false);

    useEffect(() => {
        // /scoreGame/:gamecode es una ruta de sesión larga (planilla en
        // vivo) que tampoco debe mostrar Sidebar/Navbar/BottomNav — se
        // compara por prefijo porque incluye el gamecode dinámico.
        setIsAuthRoute(
            authRoutes.includes(location.pathname) || location.pathname.startsWith('/scoreGame/')
        );

        return () => {
            setIsAuthRoute(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return isAuthRoute;
}

export default useAuthRoute